module.exports = {
          srcSet: __webpack_public_path__ + "d5c3c5b1cd5c6aed23f671e5953231df-50.png"+" 50w",
          images:[ {path: __webpack_public_path__ + "d5c3c5b1cd5c6aed23f671e5953231df-50.png",width: 50,height: 50}],
          src: __webpack_public_path__ + "d5c3c5b1cd5c6aed23f671e5953231df-50.png",
          toString:function(){return __webpack_public_path__ + "d5c3c5b1cd5c6aed23f671e5953231df-50.png"},
          
          width: 50,
          height: 50
        }